import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpHandlerFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { SnackbarService } from '@services/snackbar.service';

const API_MESSAGES: { [key: string]: string } = {
  'org_approve_not_allowed': $localize `:@@org_approve_not_allowed:Not allowed to approve organization`,
  'org_approve_success': $localize `:@@org_approve_success:Organization approved`,
  'org_create_success': $localize `:@@org_create_success:Organization created`,
  'org_update_success': $localize `:@@org_update_success:Organization updated`,
  'org_delete_success': $localize `:@@org_delete_success:Organization deleted`,
  'user_deleted': $localize `:@@UserDeleted:Gebruiker verwijderd`,
  'user_updated': $localize `:@@UserUpdated:Gebruiker gewijzigd`,
  'user_created': $localize `:@@UserCreated:Gebruiker toegevoegd`,
  'project_edit_success': $localize `:@@ProjectUpdated:Project updated`,
  'org_contains_projects': $localize `:@@OrgContainsProjects:Organization cannot be deleted because it contains projects.`,
  'project_archived': $localize `:@@ProjectArchived:Project archived`,
  'project_unarchived': $localize `:@@ProjectUnarchived:Project unarchived`,
  'error_remote_machine_cluster_already_exists': $localize `:@@ErrorRemoteMachineClusterAlreadyExists:DeltaCube Group already exists`,
  'group_updated': $localize `:@@GroupUpdated:Group updated`,
  'password_changed': $localize `:@@PasswordChanged:Password changed successfully`,
};

export function msgInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {
  const snackbar = inject(SnackbarService);
  return next(request)
  .pipe(
    tap(e => {
      const message = e instanceof HttpResponse ? (e.body as any)?.message : null;
      if (!!message) {
        snackbar.open(API_MESSAGES[message + ''] || message);
      }
    }),
    catchError(e => {
      e.error = { reason: API_MESSAGES[e.error?.reason || e.error?.message || e.statusText] || e.error?.reason || e.error?.message || e.statusText };
      return throwError(() => e);
    })
  );
}
